// extracted by mini-css-extract-plugin
export default {"container-section":"Quote_container-section__SEcnO"};